import { WC_API_URL,WC_API_HEADER_KEY } from "../../../config/config"
import axios from "axios"

export const RegistrationAPI = async (data) => {
   try {
     const res = await axios.post(`${WC_API_URL}/referralPartners`,
      data,
      {
         headers:{
            'x-internal-key' : WC_API_HEADER_KEY
         }
      }
     )
     return {success:true,res}
   } catch (error) {
      return {
            success:false,
            message:error?.response?.data?.message,
            error
        }
   }
}